import React, {useEffect, useState, useMemo, useCallback} from 'react';
import SelectDropdown from '../SelectDropdown/SelectDropdown';
import {labels} from '../../../util/utils';
import {useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';
import ProgressBar from '../BaseComponentWrappers/MotifProgressBar';
import EllipsesControl from '../EllipsesControl/EllipsesControl';
import Utility from '../../../util/utilityfunctions';
import {ShareResponseType, serviceURL, DocumentStatus, LinkType} from '../../../util/uiconstants';
import Moment from 'moment';
import Icon from '../BaseComponentWrappers/MotifIcon';
import Modal from '../Modal/Modal';
import env from '../../../util/env';
import {createLinkedResponse} from '../../../actions/Ares/linkedResponse';
import {updateDocumentStatus, updateIsShared} from '../../../actions/Ares/taskDocumentActions';
import {getAllDocuments} from '../../../actions/Document/documentactions';
import {useUserPreferences} from '../../../util/customHooks';
import MotifTableWrapper from '../BaseComponentWrappers/MotifTableWrapper';
import DocumentLabelCellRenderer from './DocumentTableCellRenderer/DocumentLabelCellRenderer';
import DocumentModifiedDateCellRenderer from './DocumentTableCellRenderer/DocumentModifiedDateCellRenderer';
import {pagingOptions} from '../../../util/uiconstants';
import ShareActivityEllipsisHeaderComponent from './DocumentTableCellRenderer/ShareActivityEllipsisHeaderComponent';
import _ from 'lodash';
import Search from '../BaseComponentWrappers/MotifSearch';
import Checkbox from '../BaseComponentWrappers/MotifCheckbox';
import Tooltip from '../BaseComponentWrappers/MotifTooltip';
import {getConfiguration} from './ShareCopyActivityConfiguration';
import {IconoirInfoCircle, IconoirWarningCircle} from '@ey-xd/motif-icon';
import Pagination from '../Pagination/Pagination';

let gridApi;
export default function ShareActivityModal(props) {
	const {
		engagementId,
		currentDocument,
		engagementMetaData,
		onHideShareActivityModal,
		showShareActivityModal,
		isAresView = true,
		modalsize = 'medium',
		showButtons = true,
		linkType
	} = props;

	const dispatch = useDispatch();
	const [shareActivityModalLoading, setShareActivityModalLoading] = useState(false),
		[selectedEngagement, setSelectedEngagement] = useState(null),
		[selectedShareResponseType, setSelectedShareResponseType] = useState(null),
		[isEngagementSelectedHasAlreadyShared, setIsEngagementSelectedHasAlreadyShared] = useState(false),
		[isEngagementSelectedHasNoSharedActivity, setIsEngagementSelectedHasNoSharedActivity] = useState(false),
		[disableAllOtherDocuments, setDisableAllOtherDocuments] = useState(false),
		[disableSharedDocuments, setDisableSharedDocuments] = useState(false),
		[isSelectedEngagementDocumentLoaded, setIsSelectedEngagementDocumentLoaded] = useState(false),
		[rowData, setRowData] = useState([]),
		[selectedDocument, setSelectedDocument] = useState([]),
		[searchText, setSearchText] = useState(''),
		[showWarning, setShowWarning] = useState(false),
		[currentPage, setCurrentPage] = useState(1),
		[pageSize, setPageSize] = useState(pagingOptions.options[0]),
		[totalPages, setTotalPages] = useState(1);

	const [showSelected, setShowSelected] = useState(false);

	const userPreferences = useUserPreferences();
	const isEngagementSelectedToShareActivity = selectedEngagement && selectedEngagement?.value;
	const currentWorkSpaceId = engagementMetaData?.filter((data) => String(engagementId) === String(data.engagementid));
	const documentsLastModifiedInformation = useSelector((state) => state.documentsLastModifiedInformation);
	const aresTaskList = useSelector((store) => store.aresTaskList);
	const documents = useSelector((state) => state.documents.byId);

	const config = useMemo(() => getConfiguration(linkType), [linkType]);

	const currentDocumentName =
		currentDocument?.documentName || aresTaskList?.byId[currentDocument?.taskId]?.knowledgeTaskShortName;

	const sameWorkSpaceEngagements = engagementMetaData?.filter((data) => {
		return (
			currentWorkSpaceId[0].workspaceid === data.workspaceid && currentWorkSpaceId[0].engagementid !== data.engagementid
		);
	});

	const engagementOptions = sameWorkSpaceEngagements?.length
		? [
				{
					value: Number(engagementId),
					label: labels.thisEngagement
				},
				{
					value: -1,
					label: labels.otherEngagemntDropdownlabel,
					isDisabled: true
				},
				...sameWorkSpaceEngagements?.map((data) => {
					return {
						value: data.engagementid,
						label: data.engagementdescription
					};
				})
		  ]
		: [
				{
					value: Number(engagementId),
					label: labels.thisEngagement
				}
		  ];

	const showScrollBar = useMemo(() => {
		return pagingOptions.options[pageSize] > 5 && rowData.length > 5;
	}, [rowData, pageSize]);

	const handleOnPageSizeChange = useCallback((pageSize) => {
		setPageSize(pageSize);
		setCurrentPage(1);
	}, []);

	const handleOnPageChange = useCallback((pageNumber) => {
		setCurrentPage(pageNumber);
	}, []);

	const onSetData = () => {
		let currentRowData;
		const getFilteredDocuments = () => {
			return Object.keys(documents)
				.filter((key) => currentDocument.id !== key)
				.map((key) => documents[key]);
		};

		const getUpdatedDocuments = () => {
			return Object.keys(documents)
				.filter((key) => currentDocument.id !== key)
				.map((key) => {
					let doc = documents[key];
					return {
						...doc,
						disableAllOtherDocuments: disableAllOtherDocuments,
						disableSharedDocuments: disableSharedDocuments,
						isSelectedDocument: !!selectedDocument.find((x) => x.id === doc.id)
					};
				});
		};

		if (isSelectedEngagementDocumentLoaded) {
			const data = getFilteredDocuments();
			currentRowData = _.sortBy(data, 'documentName');
		}

		if (disableAllOtherDocuments || disableSharedDocuments) {
			const data = getUpdatedDocuments();
			currentRowData = _.sortBy(data, 'documentName');
		}

		if (currentRowData && currentRowData.length > 0) {
			setTotalPages(Math.ceil(currentRowData.length / pageSize));
			setRowData(currentRowData.slice((currentPage - 1) * pageSize, currentPage * pageSize));
		}
	};

	useEffect(() => {
		onSetData();
	}, [isSelectedEngagementDocumentLoaded, disableAllOtherDocuments, disableSharedDocuments, pageSize, currentPage]);

	const formatOptionLabel = ({label}) => {
		return <EllipsesControl content={label} noOfLines={1} />;
	};

	const getDocumentLatestModifiedDateTime = (document) => {
		let modifiedDate;
		const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
		const documentLastModifiedData = documentsLastModifiedInformation.find((doc) => {
			return doc.documentId === document?.id;
		});

		modifiedDate =
			documentLastModifiedData && documentLastModifiedData?.modifiedDate
				? documentLastModifiedData?.modifiedDate
				: document?.modifiedDate;
		return Moment.utc(modifiedDate).format(dateTimeFormat);
	};

	const getLocalModifiedDateTime = (modifiedDate) => {
		const userDateTimeFormat = Utility.getUserPreferencesDateValue(userPreferences); // + ' hh:mm A';
		const date = Moment.utc(modifiedDate)
			.locale(Utility.getLocale(userPreferences))
			.local()
			.format(userDateTimeFormat);
		return Utility.getLocalizedFormattedDateTime(date);
	};

	useEffect(() => {
		// Selected engagement does not have corresponding activity
		setIsEngagementSelectedHasNoSharedActivity(
			isSelectedEngagementDocumentLoaded && !selectedDocument.length && !rowData.length
		);

		// Selected engagement is already shared with other engagements in the same workspace.
		setIsEngagementSelectedHasAlreadyShared(
			isSelectedEngagementDocumentLoaded && selectedDocument && selectedDocument?.isShared === true
		);

		if (selectedDocument.length) {
			const currentDocumentModifiedTime = getDocumentLatestModifiedDateTime(currentDocument);
			const isAnyDocumentNewer = selectedDocument.some(
				(document) => getDocumentLatestModifiedDateTime(document) > currentDocumentModifiedTime
			);
			setShowWarning(isAnyDocumentNewer);
		} else {
			setShowWarning(false);
		}
	}, [selectedDocument, isSelectedEngagementDocumentLoaded, selectedShareResponseType, rowData]);

	useEffect(() => {
		// If selected engagement is already shared with other engagement then we always share selected engagement to current activity.
		if (isEngagementSelectedHasAlreadyShared) {
			setSelectedShareResponseType(ShareResponseType.SelectedToCurrent);
		}
	}, [isEngagementSelectedHasAlreadyShared]);

	useEffect(() => {
		if (selectedEngagement) {
			const baseUrl = env.getBaseURL(serviceURL, selectedEngagement?.value) + 'Documents';
			const guidedWorkFlowUrl = `?documentTypeIdList=${currentDocument.documentTypeId}&filterKnowledgeForm=${currentDocument.knowledgeFormId}&PageSize=-1`;

			dispatch(getAllDocuments(baseUrl + guidedWorkFlowUrl))
				.then(() => {
					setIsSelectedEngagementDocumentLoaded(true);
				})
				.catch(() => {
					setIsSelectedEngagementDocumentLoaded(false);
				})
				.finally(() => {
					setShareActivityModalLoading(false);
					onSearchClear();
				});
		}
	}, [selectedEngagement]);

	const handleOnEngagementSelect = (engagement) => {
		if (
			(engagement && selectedEngagement === null) ||
			(selectedEngagement && engagement?.value !== selectedEngagement?.value)
		) {
			setIsSelectedEngagementDocumentLoaded(false);
			setShareActivityModalLoading(true);
			setSelectedEngagement(engagement);
			setSelectedDocument([]);
			setShowSelected(false);
			setDisableAllOtherDocuments(false);
			setDisableSharedDocuments(false);
		}
	};

	const onHideShareActivity = () => {
		setShareActivityModalLoading(false);
		setIsSelectedEngagementDocumentLoaded(false);
		setIsEngagementSelectedHasNoSharedActivity(false);
		setIsEngagementSelectedHasAlreadyShared(false);
		onHideShareActivityModal();
		//dispatch(updateDocumentStatus(currentDocument.taskId, 0));
	};

	const onShareActivity = () => {
		let url, payload;

		const documentsWithNoSharedDocs = selectedDocument?.filter(
			(doc) => doc.id !== currentDocument?.id && !doc.isShared
		);

		const documentWithSharedDoc = selectedDocument?.find((doc) => doc.id !== currentDocument?.id && doc.isShared);

		if (documentsWithNoSharedDocs?.length > 0) {
			url = env.getBaseURL(serviceURL, documentsWithNoSharedDocs[0]?.engagementId) + 'LinkedForms';
			payload = {
				sourceDocumentId: currentDocument?.id,
				sourceEngagementId: currentDocument?.engagementId,
				targetDocumentIds: documentsWithNoSharedDocs.map((doc) => doc.id)
			};
		} else if (documentWithSharedDoc) {
			url = env.getBaseURL(serviceURL, currentDocument?.engagementId) + 'LinkedForms';
			payload = {
				sourceDocumentId: documentWithSharedDoc?.id,
				sourceEngagementId: documentWithSharedDoc?.engagementId,
				targetDocumentIds: [currentDocument?.id]
			};
		}

		if (!url || !payload) return; // Exit early if no documents were found

		let documentStatus = DocumentStatus.LinkInProgress;

		if (linkType === LinkType.Copy) {
			url += '?isCopy=true';
			documentStatus = DocumentStatus.CopyInProgress;
		}

		dispatch(createLinkedResponse(url, payload)).then(() => {
			dispatch(updateDocumentStatus(currentDocument.taskId, documentStatus));
			dispatch(updateIsShared(currentDocument.taskId, currentDocument.id, true));
			onHideShareActivityModal();
		});
	};

	const onChange = (e, rowData) => {
		if (e.currentTarget.checked) {
			setSelectedDocument(selectedDocument.concat(rowData));
			setDisableAllOtherDocuments(e.currentTarget?.checked && rowData.isShared);
			setDisableSharedDocuments(e.currentTarget?.checked && !rowData.isShared);
		} else {
			var data = selectedDocument.filter((x) => x.id !== rowData.id);
			setSelectedDocument(data);

			if (data.length === 0) {
				setDisableAllOtherDocuments(false);
				setDisableSharedDocuments(false);

				if (showSelected) {
					setShowSelected(false);
					onSetData();
				}
			}
		}
	};

	const columnDefs = [
		{
			field: 'documentName',
			headerComponent: ShareActivityEllipsisHeaderComponent,
			headerComponentParams: {
				label: labels.documentContainerLabel
			},
			cellRenderer: 'DocumentLabelCellRenderer',
			cellRendererParams: {
				setSelectedDocument: setSelectedDocument,
				selectedDocument: selectedDocument,
				onChange: onChange
			},
			showToolTip: config.showDisabled,
			maxWidth: '400',
			hide: false,
			suppressMovable: true,
			getQuickFilterText: (params) => {
				const documentNameAndExtension = `${params?.data?.documentName}.${params?.data?.fileExt}`;
				return documentNameAndExtension && documentNameAndExtension.toLowerCase().replace(' ', '');
			}
		},
		{
			field: '',
			headerComponent: ShareActivityEllipsisHeaderComponent,
			cellRenderer: (params) => {
				return (
					<>
						{config.showDisabled ? (
							<>
								{params?.data?.isShared && (
									<span className="sharedPillText">{params?.data?.isShared ? labels.shared : ''}</span>
								)}
							</>
						) : (
							<Tooltip
								className={'shareActivityDocumentTooltip'}
								variant="alt"
								allowClick={false}
								allowHover
								placement="top"
								closeButtonProps={{
									className: 'hide'
								}}
								trigger={
									<>
										{params?.data?.isShared && (
											<span className="sharedPillText">{params?.data?.isShared ? labels.shared : ''}</span>
										)}
									</>
								}
							>
								{labels.sharedHoverLabel}
							</Tooltip>
						)}
					</>
				);
			},
			hide: false,
			suppressMovable: true
		},
		{
			field: 'ModifiedDateTime',
			headerComponent: ShareActivityEllipsisHeaderComponent,
			headerComponentParams: {
				label: labels.lastModifiedon
			},
			cellRenderer: 'documentModifiedDateCellRenderer',
			maxWidth: '200',
			hide: false,
			suppressMovable: true
		}
	];

	const handleGridReady = (params) => {
		gridApi = params.api;
	};

	const frameworkComponents = {
		DocumentLabelCellRenderer: DocumentLabelCellRenderer,
		documentModifiedDateCellRenderer: DocumentModifiedDateCellRenderer
	};

	const onChangeSearch = (event) => {
		setSearchText(event.target.value);
		onSearch(event.target.value);
	};

	const onSearch = (searchInput) => {
		if (gridApi) {
			const searchString = searchInput ?? searchText;
			if (searchString.trim() !== '') {
				gridApi.setGridOption('quickFilterText', searchString.toLowerCase().replace(' ', ''));
				gridApi.getDisplayedRowCount() === 0 ? gridApi.showNoRowsOverlay() : gridApi.hideOverlay();
			} else {
				onSearchClear();
			}
		}
	};

	const onSearchClear = () => {
		if (gridApi) {
			gridApi.setGridOption('quickFilterText', '');
			setSearchText('');
			gridApi.hideOverlay();
		}
	};

	const onShowSelected = (e) => {
		if (e.currentTarget.checked) {
			setShowSelected(true);
			var data = rowData.filter((x) => selectedDocument.find((y) => y.id === x.id));
			setRowData(data);
		} else {
			setShowSelected(false);
			onSetData();
		}

		setTimeout(() => {
			gridApi.getDisplayedRowCount() === 0 ? gridApi.showNoRowsOverlay() : gridApi.hideOverlay();
		}, 0);
	};

	return (
		<Modal
			show={showShareActivityModal}
			modalsize={modalsize}
			showButtons={showButtons}
			isOkButtonDisabled={
				!(
					isEngagementSelectedToShareActivity &&
					isSelectedEngagementDocumentLoaded &&
					!isEngagementSelectedHasNoSharedActivity &&
					selectedDocument.length > 0
				)
			}
			title={config.modalTitle}
			closeTitle={labels.modalCloseTitle}
			confirmBtnTitle={config.confirmBtnTitle}
			closeBtnTitle={labels.modalCancelTitle}
			modalContainerClass={`sharingActivityModalContainer ${shareActivityModalLoading &&
				'sharingActivityModalContainerLoader'}`}
			modalbodystyle={'sharingActivityModalBody customScrollbar'}
			isAresView={isAresView}
			onHide={onHideShareActivity}
			onOkClick={onShareActivity}
		>
			<StyledSharingActivityModalContainer className="sharingActivityModalContainer">
				{shareActivityModalLoading && (
					<section className="MotifProgressBarWrapper">
						<ProgressBar className="sharingActivityLoader" isIndeterminate circle hideLabel />
					</section>
				)}
				<section className="sharingActivityInfoWrapper">
					<section className="sharing-activity-info">{config.modalInfo}</section>
					<section className="currentActivityWrapper">
						<section className="currentActivityName">{currentDocumentName}</section>
						<section className="lastModifiedDate">
							<section className="lastModifiedDateLabel">{labels.lastModifiedDate}</section>
							<section className="lastModifiedDateValue">
								{getLocalModifiedDateTime(getDocumentLatestModifiedDateTime(currentDocument))}
							</section>
						</section>
					</section>

					<SelectDropdown
						formLabel={config.dropdownPlaceholder}
						className={'shareActivity-engagements-dropdown'}
						options={engagementOptions}
						isOptionDisabled={(option) => option.isDisabled}
						isSearchable={false}
						onChange={handleOnEngagementSelect}
						value={selectedEngagement}
						maxOptionsBeforeScroll={5}
						formatOptionLabel={formatOptionLabel}
						defaultValue={selectedEngagement}
					/>

					{isSelectedEngagementDocumentLoaded && !isEngagementSelectedHasNoSharedActivity && (
						<section className="sharingDocumentWrapper">
							<span className="sharingDocumentText">{config.documentsEngagementLabel}:</span>
							<section className="shareActivityDocumentSearchWrapper">
								<Search
									id="shareActivityDocument"
									styleName="shareActivityDocumentSearch"
									value={searchText}
									placeholder={labels.placeholderForSearch}
									searchHoverText={labels.placeholderForSearch}
									clearHoverText={labels.clearHoverText}
									onChange={onChangeSearch}
									onSearchButtonClick={onSearch}
									onEnter={onSearch}
									onClear={onSearchClear}
								/>
								<Checkbox
									//key={`doc-name-cell-${params.valueIndex}-${params.colDef.headerName}`}
									id="showSelected"
									label={labels.showOnlySelected}
									title={labels.showOnlySelected}
									onChange={(e) => onShowSelected(e)}
									checked={showSelected}
									styleName="relateDocuments__checkbox"
									disabled={selectedDocument?.length < 1}
								/>
							</section>
							<MotifTableWrapper
								className={`StyledMotifTableWrapper ${showScrollBar ? 'StyledMotifTableContentWrapper' : ''}`}
								columnDefs={columnDefs}
								rowData={rowData}
								onGridReady={handleGridReady}
								suppressRowClickSelection
								suppressCellFocus
								suppressHorizontalScroll
								rowBuffer={200}
								animateRows
								onSortChanged={() => gridApi.redrawRows()}
								components={frameworkComponents}
								overlayNoRowsTemplate={labels.noResultsFound}
								enableBrowserTooltips
								pagination={false}
								rowHeight={48}
							/>
							<section className="paging">
								<Pagination
									className="sharing-paging"
									optionsPerPage={pagingOptions.options}
									page={currentPage}
									pageSize={pageSize}
									pageCount={totalPages}
									onPageSizeChanged={handleOnPageSizeChange}
									onPageChanged={handleOnPageChange}
								/>
							</section>
						</section>
					)}

					{isEngagementSelectedToShareActivity && isEngagementSelectedHasNoSharedActivity && (
						<section className="selectedActivityNoSharedInfo">
							<Icon src={IconoirInfoCircle} />
							<span className="noSharedActivityInfoLabel">{config.noRequiredActivityLabel}</span>
						</section>
					)}
					{gridApi && gridApi.getDisplayedRowCount() !== 0 && showWarning && (
						<section className="selectedActivityWarningInfo">
							<Icon src={IconoirWarningCircle} />
							<span className="selectActivityResponsesWarningLabel">{config.warningMessage}</span>
						</section>
					)}
				</section>
			</StyledSharingActivityModalContainer>
		</Modal>
	);
}

const StyledSharingActivityModalContainer = styled.section`
	height: 100%;
	.MotifProgressBarWrapper {
		width: calc(100% - var(--px-30));
		height: calc(100% - var(--px-130));
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		z-index: 9;
		background: var(--neutrals-00white);
	}
	.sharingActivityInfoWrapper {
		height: calc(100% - var(--px-48));
		.SelectDropdownContainer {
			height: var(--px-44);
			&.DropdownMenuOptionsClosed {
				.react-select-label {
					top: var(--px-12);
				}
			}
			&.floating-label {
				.react-select-label {
					top: var(--px-4);
				}
			}
			.react-select__control {
				min-height: var(--px-44);
				height: var(--px-44);
			}
		}
	}
	.sharing-activity-info {
		font-size: var(--px-16);
		font-weight: 300;
		line-height: var(--px-24);
		color: var(--neutrals-900);
		padding-bottom: var(--px-24);
		border-bottom: var(--px-1) solid var(--neutrals-200);
	}
	.currentActivityWrapper {
		border-bottom: var(--px-1) solid var(--neutrals-200);
		padding: var(--px-24) 0;
		margin-bottom: var(--px-24);
		.currentActivityName {
			font-size: var(--px-16);
			font-weight: 700;
			line-height: var(--px-24);
			color: var(--neutrals-900);
		}
		.lastModifiedDate {
			display: flex;
			.lastModifiedDateLabel {
				font-size: var(--px-12);
				font-weight: 300;
				line-height: var(--px-16);
				color: var(--neutrals-900);
			}
			.lastModifiedDateValue {
				font-size: var(--px-12);
				font-weight: 300;
				line-height: var(--px-16);
				color: var(--neutrals-900);
				margin-left: var(--px-5);
			}
		}
	}
	.sharingDocumentWrapper {
		margin-top: var(--px-24);
		.paging {
			float: right;
			margin: var(--px-8) var(--px-24);
		}
		.sharingDocumentText {
			font-size: var(--px-14);
			font-weight: 400;
			line-height: var(--px-20);
			color: var(--neutrals-900);
		}
		.shareActivityDocumentSearchWrapper {
			display: flex;
			.shareActivityDocumentSearch {
				width: var(--px-420);
				margin-top: var(--px-8);
				.motif-form-field {
					height: 100% !important;
				}
				.motif-input {
					height: var(--px-44) !important;
				}
			}
			.relateDocuments__checkbox {
				width: auto;
				margin-left: auto;
				display: flex;
				align-items: flex-end;
				.motif-checkbox {
					.motif-checkbox-label {
						width: 100%;
					}
				}
			}
		}
	}
	.shareActivity-engagements-dropdown {
		.react-select-label {
			color: var(--neutrals-700) !important;
			cursor: pointer;
		}
		.react-select-container {
			.react-select__menu {
				.react-select__menu-list {
					max-height: var(--px-200);
					margin: 0;
					.react-select__option {
						&:hover {
							cursor: default !important;
						}
						&.react-select__option--is-disabled {
							background-color: var(--neutrals-50) !important;
						}
					}
				}
			}
		}
	}
	.StyledMotifTableWrapper {
		margin-top: var(--px-24);
		overflow: visible;
		.motif-table {
			border: 0;
			margin: 0;
			.ag-root-wrapper {
				border: none;
				.ag-root-wrapper-body {
					border: var(--px-1) solid transparent;
					border-radius: var(--px-12);
					background: transparent;
					.ag-overlay {
						.ag-overlay-panel {
							.ag-overlay-wrapper {
								color: var(--neutrals-700) !important;
								font-size: var(--px-14);
								font-weight: 400;
								line-height: var(--px-24);
							}
							.ag-overlay-no-rows-wrapper {
								padding-top: var(--px-50);
							}
						}
					}
					.ag-root-wrapper-body {
						height: 100% !important;
					}
				}
				.ag-header {
					border: var(--px-1) solid var(--neutrals-200) !important;
					background-color: var(--neutrals-25);
					height: var(--px-48) !important;
					min-height: var(--px-48) !important;
					.ag-header-viewport {
						.ag-header-container {
							width: 100% !important;
							.ag-header-row {
								width: 100% !important;
								display: flex;
								height: 100% !important;
								padding-right: var(--px-6);
								.ag-header-cell {
									font-size: var(--px-14);
									font-weight: 400;
									width: 20% !important;
									position: static;
									padding: var(--px-10) var(--px-8) var(--px-10) var(--px-16);
									height: var(--px-48) !important;
									.ag-header-cell-comp-wrapper {
										.ellipses {
											justify-content: center;
											font-size: var(--px-14);
											font-weight: 400;
											line-height: var(--px-24);
											color: var(--neutrals-900);
											div {
												font-weight: 400;
											}
										}
										.motif-table-header-renderer {
											max-width: 100%;
										}
									}
									.ag-header-cell-label {
										display: flex;
										justify-content: flex-end;
										.ag-header-cell-text {
											font-size: var(--px-14);
											font-weight: 400;
											line-height: var(--px-24);
											color: var(--neutrals-900);
										}
									}
									&:first-child {
										width: 80% !important;
										padding: var(--px-10) var(--px-16);
										.ag-header-cell-comp-wrapper {
											.ellipses {
												justify-content: flex-start;
											}
										}
									}
									&:last-child {
										.ag-header-cell-comp-wrapper {
											.ellipses {
												justify-content: flex-start;
												div {
													min-width: var(--px-150);
												}
											}
										}
									}
									&:hover,
									&:focus {
										background-color: transparent;
									}
								}
								.motif-table-header-title {
									font-weight: 400;
									font-size: var(--px-14);
									line-height: var(--px-24);
									width: calc(100% - var(--px-20));
								}
							}
						}
					}
				}
				.ag-body-viewport {
					margin-bottom: 0;
					background: var(--neutrals-00white);
					border: var(--px-1) solid var(--neutrals-200) !important;
					border-radius: 0 0 var(--px-12) var(--px-12);
					overflow-y: auto;
					&::-webkit-scrollbar {
						height: var(--px-6);
						width: var(--px-6);
					}
					&::-webkit-scrollbar-track {
						background: var(--neutrals-200);
						height: var(--px-6);
						width: var(--px-6);
					}
					&::-webkit-scrollbar-thumb {
						background: var(--neutrals-300);
						height: var(--px-6);
						width: var(--px-6);
						cursor: pointer;
					}
					&::-webkit-scrollbar-thumb:hover {
						background: var(--neutrals-700);
					}
					.ag-center-cols-clipper:has(.ag-center-cols-container):has(.ag-row) {
						min-height: var(--px-60);
						.ag-center-cols-container {
							min-height: var(--px-60);
						}
					}
					.ag-center-cols-container {
						width: 100% !important;
					}
					.ag-row {
						display: flex;
						border: 0;
						padding-right: var(--px-6);
						&.ag-row-even {
							background: var(--neutrals-25);
						}
						&.ag-row-odd {
							background: var(--neutrals-00white);
						}
						.ag-cell {
							width: 20% !important;
							position: static;
							padding: var(--px-10) var(--px-8) var(--px-10) var(--px-16);
							height: 100%;
							font-size: var(--px-14);
							font-weight: 300;
							line-height: var(--px-24);
							color: var(--neutrals-900);
							display: flex;
							justify-content: flex-end;
							.sharedPillText {
								border: var(--px-1) solid var(--neutrals-900);
								border-radius: var(--px-16);
								padding: var(--px-3) var(--px-10);
								font-size: var(--px-12);
								font-weight: 400;
								line-height: var(--px-18);
								color: var(--neutrals-900);
							}

							&:last-child {
								justify-content: flex-start;
								.lastModifiedDateValue {
									min-width: var(--px-150);
									justify-content: flex-start;
									display: flex;
								}
							}

							&:first-child {
								width: 80% !important;
								padding: var(--px-10) var(--px-16);
								justify-content: flex-start;
								.relateDocuments__checkbox {
									width: 100%;
									.motif-checkbox {
										.motif-checkbox-label {
											width: 100%;
										}
									}
								}
								.section-radio {
									padding: var(--px-8) 0;
									width: 100%;
								}
							}
							&:hover,
							&:focus {
								background-color: transparent;
							}
							.motif-checkbox-input,
							.motif-checkbox-label {
								font-size: var(--px-14) !important;
								font-weight: 300 !important;
								line-height: var(--px-20) !important;
							}
						}
						&.ag-row-hover {
							&::before {
								background-color: transparent;
							}
						}
						&:has(input:disabled) {
							.ag-cell {
								.relateDocuments__checkbox {
									width: auto;
									.motif-checkbox-disabled {
										.motif-checkbox-label {
											width: auto;
										}
									}
								}
								.sharedPillText {
									border-color: var(--neutrals-300);
									color: var(--neutrals-300);
								}
								.lastModifiedDateValue {
									color: var(--neutrals-300);
								}
							}
						}
					}
				}
				.pagination-control-wrapper {
					.informationIcon {
						.motif-icon {
							svg {
								fill: var(--neutrals-700);
								path {
									fill: var(--neutrals-700);
								}
							}
						}
						.informationText {
							color: var(--neutrals-900);
							font-size: var(--px-14);
							font-weight: 300;
							line-height: var(--px-24);
							margin-left: var(--px-6);
							justify-content: flex-start;
						}
					}
					.pagination-show {
						margin: 0 var(--px-5) 0 auto;
						display: flex;
						align-items: center;
						color: var(--neutrals-900);
					}
					.motif-select {
						margin-top: calc(var(--px-8) * -1);
						width: var(--px-70);
						.motif-select-input {
							svg {
								top: var(--px-12);
							}
						}
					}
					.motif-pagination {
						margin-right: 0;
						.motif-icon-button {
							svg {
								path {
									fill: var(--neutrals-900);
								}
							}
							&:disabled {
								svg {
									path {
										fill: var(--neutrals-700);
									}
								}
							}
						}
					}
				}
			}
		}
		&.StyledMotifTableContentWrapper {
			.motif-table {
				.motif-table-wrapper {
					.ag-body-viewport {
						.ag-row {
							padding-right: 0;
						}
					}
				}
			}
		}
	}
	.selectedActivityNoSharedInfo {
		display: flex;
		margin-top: var(--px-25);
		.motif-icon {
			display: flex;
			align-items: center;
			svg {
				fill: var(--red-600);
				path {
					fill: var(--red-600);
				}
			}
		}
		.noSharedActivityInfoLabel {
			font-size: var(--px-14);
			font-weight: 300;
			line-height: var(--px-24);
			color: var(--neutrals-900);
			display: flex;
			width: calc(100% - var(--px-30));
			margin-left: var(--px-6);
		}
	}
	.selectedActivityWrapper {
		display: flex;
		margin-top: var(--px-8);
		margin-bottom: var(--px-24);
		.selectedActivityName {
			font-size: var(--px-14);
			font-weight: 300;
			line-height: var(--px-24);
			color: var(--neutrals-900);
			margin-right: var(--px-5);
		}
		.selectedActivityLastModifiedInfo {
			display: flex;
			.selectedActivityInfoLabel,
			.selectedActivityLastModifedDataValue {
				font-size: var(--px-14);
				font-weight: 300;
				line-height: var(--px-24);
				color: var(--neutrals-900);
				margin-right: var(--px-5);
			}
		}
	}
	.selectedActivityAlreadySharedInfo {
		display: flex;
		margin-top: var(--px-8);
		.motif-icon {
			svg {
				fill: var(--orange-700);
				path {
					fill: var(--orange-700);
				}
			}
		}
		.alreadyHasSharedActivityInfoLabel {
			font-size: var(--px-14);
			font-weight: 300;
			line-height: var(--px-24);
			color: var(--neutrals-900);
			display: flex;
			width: calc(100% - var(--px-30));
			margin-left: var(--px-6);
		}
	}
	.selectActivityForSharingWrapper {
		.selectActivityForSharingLable {
			font-size: var(--px-14);
			font-weight: 400;
			line-height: var(--px-24);
			color: var(--neutrals-900);
			margin-bottom: var(--px-8);
			.selectActivityForSharingText {
				font-size: var(--px-14);
				font-weight: 400;
				line-height: var(--px-24);
				color: var(--neutrals-900);
			}
		}
	}
	.selectedActivityWarningInfo {
		display: flex;
		margin-top: var(--px-8);
		margin-bottom: var(--px-16);
		.motif-icon {
			margin-bottom: var(--px-16);
			display: flex;
			align-items: center;
			svg {
				fill: var(--orange-700);
				path {
					fill: var(--orange-700);
				}
			}
		}
		.selectActivityResponsesWarningLabel {
			font-size: var(--px-14);
			font-weight: 300;
			line-height: var(--px-24);
			color: var(--neutrals-900);
			display: flex;
			width: calc(100% - var(--px-30));
			margin-left: var(--px-6);
			margin-bottom: var(--px-16);
		}
	}
`;
